/*
 *   Copyright (c) 2020 BuserNet Consulting LLC
 *   All rights reserved.
 */
export default {
  geoDiscStyle: {
    strokeWeight: '3',
    strokeColor: '#7f7fff',
  },
  mapDarkStyleSource: 'static/json/mapDarkStyle.json',
  mapLightStyleSource: 'static/json/mapLightStyle.json',
  layerUrls: {
    Esri_WorldTopoMap: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}',
    Stamen_Terrain: 'https://stamen-tiles-{s}.a.ssl.fastly.net/terrain/{z}/{x}/{y}.{ext}',
    OpenStreetMap_BlackAndWhite: 'http://{s}.tiles.wmflabs.org/bw-mapnik/{z}/{x}/{y}.png',
  },
  fetchingAirportInfo: 'Fetching airport details',
  mapSetHeightDelay: 250,
  mapStyle: {
    dark: null,
    light: null,
  },
  icaoOffset: {
    x: 15,
    y: 5,
  },
  flightDotOffset: {
    icaoOffset: 4,
    etaOffset: 2,
  },
  mapMosNum: {
    web: 300,
    iPhone: 150,
    iPad: 200,
  },
  flightDotRadius: 4,
  mapMosStyles: {
    strokewidth: 10,
    stroke: '#fff',
    radius: 50,
  },
  mapMetarStyles: {
    strokewidth: 20,
  },
  metarZoomThreshold: 7,
  mapPanningDebounce: 500,
  defaultButtonPosition: 'topright',
  defaultMapStyle: 'light',
  bigDotsZoomThreshold: 8,
  flightSquaresiPhonePercent: 75,
  flightSquaresiPadPercent: 116,
  flightSquares: 24,
  flightSquaresiPhoneMosPercent: 116,
  flightSquaresiPadMosPercent: 166,
  flightSquaresMos: 12,
  metarSizePercentOfMos: 80,
};
